<template>
  <v-app id="app">
    <div
      class=""
      :class="
        this.$route.fullPath === '/dashboard' ||
        this.$route.fullPath === '/login' ||
        this.$route.fullPath === '/'
          ? 'app-container'
          : 'app'
      "
    >
      <!-- <transition mode="out-in"> -->
      <router-view />
      <!-- </transition> -->
      <toaster></toaster>
    </div>
  </v-app>
</template>

<script>
// Component
import toaster from './components/Toast.vue';

export default {
  components: {
    toaster,
  },
};
</script>

<style lang="scss">
@import '@/assets/style/_reset.scss';
@import '@/assets/style/_fonts.scss';
@import '@/assets/style/_icons.scss';

* {
  font-family: 'DM Sans Regular', sans-serif;
}

:root {
  --black: #000000;
  --default-black: #1d1e25;
  --neutral-black: #161927;
  --neutral-grey: #b8c1c8;
  --white: #ffffff;
  --grey: #9096a4;
  --grey-day-010: #f6f5f6;
  --grey-day-020: #f0f1f3;
  --grey-day-030: #e3e5e6;
  --grey-day-060: #404e62;
  --grey-day-070: #394557;
  --grey-day-080: #303c4c;
  --grey-day: #626772;
  --black-090: #0c0e14;
  --light-grey: #e7e9ef;
  --dark-grey: #4f5963;
  --dark-red: #d6172a;
  --red: #e83d4e;
  --yellow: #e5bd29;
  --dark-green: #079372;
  --green: #00bf92;
  --light-green: #daf3ec;
  --blue: #2282f3;

  --dm-sans-bold: 'DM Sans Bold', Arial, sans-serif;
  --dm-sans-medium: 'DM Sans Medium', Arial, sans-serif;
  --dm-sans-regular: 'DM Sans Regular', Arial, sans-serif;
}

.app {
  display: flex;
  justify-content: start;
  font-family: var(--dm-sans-regular);
  background: var(--grey-day-010);
  height: 100vh;
  padding-left: 430px;
  // overflow-x: scroll;
}

.app-container {
  display: flex;
  justify-content: center;
  font-family: var(--dm-sans-regular);
  background: var(--grey-day-010);
  height: 100vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.grecaptcha-badge {
  display: none;
}

.v-pagination__navigation,
.v-pagination__item {
  border: none !important;
  box-shadow: none !important;
}

body {
  font-family: 'DM Sans Regular', sans-serif !important;
}

.vs__dropdown-toggle {
  border: none !important;
}

.push-app__select .vs__open-indicator {
  display: none;
}

.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity 2s;
}
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: opacity 2s;
}
.v-enter-to {
  opacity: 1;
}

.mx-input-wrapper {
  width: 100% !important;
  padding-left: 7px;
}

@media screen and (max-width: 1377px) {
  .app-container {
    // height: 90vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue